import React from 'react';
import Text from './Text';
import ModalBackButton from './ModalBackButton';

const ModalHeader = ({
  backClick,
  title,
  showCloseButton = false,
}: {
  backClick: () => void;
  title: string;
  showCloseButton?: boolean;
}) => {
  return (
    <div style={styles.headerContainer}>
      <div style={styles.modalBackButtonContainer}>
        <ModalBackButton onClick={backClick} showCloseButton={showCloseButton} />
      </div>
      <div style={styles.titleContainer}>
        <Text value={title} themeKey="modalHeader" />
      </div>
      <div style={styles.rightSpacer}></div>
    </div>
  );
};

const styles: Styles = {
  headerContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    position: 'relative',
    padding: 16,
    borderBottom: '1px solid #eee',
  },
  modalBackButtonContainer: {
    flex: '0 0 auto',
    minWidth: 40,
    display: 'flex',
    alignItems: 'center',
  },
  titleContainer: {
    flex: '1 1 auto',
    textAlign: 'center',
  },
  rightSpacer: {
    flex: '0 0 auto',
    minWidth: 40,
  },
};

export default ModalHeader;
